module.exports = {"540103001":"东嘎街道","540103002":"乃琼街道","540103003":"羊达街道","540103004":"柳梧街道","540103102":"古荣镇","540103103":"马镇","540103104":"德庆镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540103.json
// module id = 2810
// module chunks = 0